/**
 * The facility calendar keeps two choices in the browser tab: the column
 * type (coaches or resources) and the compare coach. A new tab starts on the
 * coach columns. The view menu of each calendar page writes the column type
 * here, so the facility page opens on the last choice. The key and its two
 * values are the ones of the old Coaches/Resources switch.
 */
export const VIEW_STORAGE_KEY = "facilityCalendar_view";
export const COMPARE_COACH_STORAGE_KEY = "facilityCalendar_compareCoachId";

// The browser can refuse storage. The two functions below catch that error,
// and the page continues.
export function readStoredValue(key: string): string | null {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStoredValue(key: string, value: string): void {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // The tab refuses storage. The choice then lasts until the next reload.
  }
}

export function readStoredResourceView(): boolean {
  return readStoredValue(VIEW_STORAGE_KEY) === "resources";
}

export function storeResourceView(resourceView: boolean): void {
  writeStoredValue(VIEW_STORAGE_KEY, resourceView ? "resources" : "coaches");
}
